import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { ICmsTicketOverviewItem } from '@web/dtos';
import { getTicketSortIcon } from '@web/shared-functions/sort-group';

@Component({
  selector: 'aw-ticket-sort-button',
  imports: [],
  templateUrl: './ticket-sort-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketSortButtonComponent {
  public ticketSort: InputSignal<ICmsTicketOverviewItem> =
    input.required<ICmsTicketOverviewItem>();
  public readonly isSelected: InputSignal<boolean> = input.required<boolean>();
  public readonly isEdited: InputSignal<boolean> = input.required<boolean>();
  public readonly isLayoutCompleted: InputSignal<boolean> =
    input.required<boolean>();

  protected readonly getTicketSortIcon: typeof getTicketSortIcon =
    getTicketSortIcon;
}
